export const getTenantId = (tenant) =>
  tenant?.tenantId || tenant?.subdomain || tenant?._id || '';

export const getProductId = (product) =>
  product?.productId || product?._id || '';

export const resolveTenantSelectValue = (tenantId, tenants = []) => {
  if (!tenantId) return '';
  const match = tenants.find(
    (t) =>
      t.subdomain === tenantId ||
      t._id === tenantId ||
      t.tenantId === tenantId
  );
  return match?.subdomain || tenantId;
};

export const getTenantProductDbName = (tp) => tp?.db_name || tp?.dbName || '';

export const getTenantProductDbUri = (tp) => tp?.db_uri || tp?.dbUri || '';
